exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-tag.cap-tag-v2{height:32px;display:inline-flex;align-items:center;border:none;background-color:#ebecf0}.ant-tag.cap-tag-v2 .anticon-close{font-size:16px;color:#b3bac5}.ant-tag.cap-tag-v2.static{cursor:default;pointer-events:none}.ant-tag.cap-tag-v2.disabled{background-color:#f4f5f7;cursor:not-allowed}.ant-tag.cap-tag-v2.outline{background-color:#fff;border:solid 1px #091e42}\n", ""]);

// exports
